import { ALL_CATEGORIES, type CategoryKey } from "./index";

const PATTERNS: Array<{ key: CategoryKey; tests: RegExp[] }> = [
  {
    key: "actualites-locales",
    tests: [/local/i, /r[eé]gion/i, /ville/i, /municipal/i, /quartier/i, /commun/i],
  },
  {
    key: "business-finance",
    tests: [/business/i, /finance/i, /[eé]conom/i, /march[eé]/i, /bourse/i, /capital/i, /banqu/i, /invest/i],
  },
  {
    key: "culture-magazine",
    tests: [/culture/i, /magazine/i, /lifestyle/i, /art/i, /litt[eé]rat/i, /cin[eé]ma/i, /musique/i, /mode/i],
  },
  {
    key: "sport",
    tests: [/sport/i, /football/i, /tennis/i, /rugby/i, /basket/i, /cyclism/i],
  },
  {
    key: "actualites-generales",
    tests: [/actualit[eé]/i, /general/i, /national/i, /international/i, /politiq/i, /soci[eé]t[eé]/i, /world/i, /news/i],
  },
];

export function normalizeCategory(raw: string | null | undefined): CategoryKey | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  if ((ALL_CATEGORIES as string[]).includes(trimmed)) return trimmed as CategoryKey;
  for (const { key, tests } of PATTERNS) {
    if (tests.some((re) => re.test(trimmed))) return key;
  }
  return null;
}
